export default {
	styleOverrides: {
		root: {
			'& .MuiTypography-subtitle1': {
				fontSize: '12px',
				fontWeight: 600,
			},
           
			'& .MuiAccordionSummary-expandIconWrapper': {
				'& .MuiSvgIcon-root': {
					fontSize: '1.2rem',
					color: '#000',
				},
			},
		},
	},
}
